// extracted by mini-css-extract-plugin
export default {"button":"UGoqFD","icon":"fRB7FS","label":"BlmaiP","tooltip":"LHKcjd"};